import { render, staticRenderFns } from "./Downloader.vue?vue&type=template&id=6130a179&"
import script from "./Downloader.vue?vue&type=script&lang=js&"
export * from "./Downloader.vue?vue&type=script&lang=js&"
import style0 from "./Downloader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports